import Bowser from 'bowser';
import {AnalyticsService} from 'src/analytics';
import {ANALYTICS_SCHEDULER_EVENTS} from './analytics-event-names';
import {isBrowserSupported} from '../utils/browser';
import type {IEvent} from '../types/IEvent';
import type {IEventTemplate} from '../types/IEventTemplate';


export const trackBrowserDetails = (agencyId: string, agencyName: string) => {
  const browserSupported = isBrowserSupported();
  const userAgent = window.navigator.userAgent;
  const browserDetails = Bowser.parse(userAgent);
  AnalyticsService.track(ANALYTICS_SCHEDULER_EVENTS.BOOKING_BROWSER_DETAILS, {
    'Agency id': agencyId,
    'Agency name': agencyName,
    'Browser details': browserDetails,
    'User agent': userAgent,
  });

  if (!browserSupported) {
    AnalyticsService.track(
      ANALYTICS_SCHEDULER_EVENTS.BOOKING_UNSUPPORTED_BROWSER_DETECTED,
      {
        'Agency id': agencyId,
        'Agency name': agencyName,
        'Browser details': browserDetails,
        'User agent': userAgent,
      },
    );
  }
};

type AnalyticsContext = {
  eventTemplate?: IEventTemplate;
  eventDetails?: IEvent | IEvent[];
};

export function shouldSkipSequentialAnalytics(
  context: AnalyticsContext,
): boolean {
  return (
    context.eventTemplate?.distribution_rule === 'sequential_interview' ||
    Array.isArray(context.eventDetails)
  );
}
